"use client";

import dynamic from "next/dynamic";
import type {
  ISbStoryData,
  StoryblokBridgeConfigV2,
} from "@storyblok/react/rsc";

// Code-split the Storyblok live-editing bridge — and the heavy tiptap-based
// richtext bundle it pulls in via the @storyblok/js barrel — into a lazily
// loaded chunk. A static import would ship that chunk to every visitor;
// `next/dynamic` defers it so the browser only fetches it when this component
// actually mounts. That happens solely in Storyblok draft/preview mode (see
// `liveEditing` in story.tsx), so production visitors never download it.
const StoryblokLiveEditing = dynamic(
  () => import("@storyblok/react/rsc").then((m) => m.StoryblokLiveEditing),
  { ssr: false },
);

export function LiveEditingLoader({
  story,
  bridgeOptions,
}: {
  story: ISbStoryData;
  bridgeOptions?: StoryblokBridgeConfigV2;
}) {
  return <StoryblokLiveEditing story={story} bridgeOptions={bridgeOptions} />;
}
